import { createWebviewScreen } from 'shared/src/component';

/**
 * 장바구니 쿠폰 선택 화면(`/cart/select-coupon`, 내용은 웹뷰).
 *
 * 전용 화면으로 두는 이유는 `Cart` 와 같다 — 범용 `WebViewScreen` 으로 열면 목적지가 `url`
 * params 문자열로 들어가 주소가 유지되지 않는다.
 *
 * `Cart` 는 쿼리 승계를 위해 개별 파일로 두지만, 이 화면은 경로·타이틀만 달라 팩토리로 충분하다
 * (팩토리도 path 세그먼트를 채우고 나머지 파라미터를 웹뷰 URL 쿼리로 승계한다).
 *
 * 타이틀은 SPA 라 서버 `<title>` 이 없어 지면 의미로 정했다.
 */
export const CartSelectCouponScreen = createWebviewScreen({
  screen: 'CartSelectCoupon',
  title: '쿠폰 선택',
});
